export const DELAY = 150;
export const HIDE_DURATION = 400;

export const SETTINGS = 'SETTINGS';
export const PROGRESS_RESET = 'PROGRESS_RESET';
export const LOGIN = 'LOGIN';
export const ENCYCLOPEDIA = 'ENCYCLOPEDIA';
export const STORE = 'STORE';
export const HINTS = 'HINTS';
export const SYNC = 'SYNC';
export const NEWS = 'NEWS';
export const RATING_MAIN = 'RATING_MAIN';
export const RATING_REVIEW = 'RATING_REVIEW';
export const RATING_FEEDBACK = 'RATING_FEEDBACK';

export const ALL = {
  [SETTINGS]: SETTINGS,
  [PROGRESS_RESET]: PROGRESS_RESET,
  [LOGIN]: LOGIN,
  [ENCYCLOPEDIA]: ENCYCLOPEDIA,
  [STORE]: STORE,
  [HINTS]: HINTS,
  [RATING_MAIN]: RATING_MAIN,
  [RATING_REVIEW]: RATING_REVIEW,
  [RATING_FEEDBACK]: RATING_FEEDBACK,
  [SYNC]: SYNC,
  [NEWS]: NEWS,
};

